import { render } from "./ShareTip.vue?vue&type=template&id=3acfb344&scoped=true"
import script from "./ShareTip.vue?vue&type=script&lang=js"
export * from "./ShareTip.vue?vue&type=script&lang=js"

import "./ShareTip.vue?vue&type=style&index=0&id=3acfb344&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acfb344"]])

export default __exports__